import { render, staticRenderFns } from "./ViewProductsHome.vue?vue&type=template&id=414da4fe&"
import script from "./ViewProductsHome.vue?vue&type=script&lang=js&"
export * from "./ViewProductsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports